import React, { useState } from "react";
import "./uppertopbar.css";
import UTBAnimation from "./UTBAnimation";
import { NavLink } from "react-router-dom";

export default function Uppertopbar() {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  return (
    <>
      <div className="uppertopbar">
        <div className="pointershape">
          <div className="pointershape2wrapper">
            <div className="dummydiv" />
            <div className="pointershape2" />
          </div>
          <div className="leftcontent">
            <UTBAnimation />
          </div>
        </div>
        <div className="rightcontent">
          <div className="linkzatopbar">
            <NavLink
              exact
              to="/quicklinks"
              activeClassName="active"
              className="nav-links"
              onClick={handleClick}
            >
              QUICK LINKS
            </NavLink>
          </div>

          <div className="linkzatopbar">
            <NavLink
              exact
              to="/whyus"
              activeClassName="active"
              className="nav-links"
              onClick={handleClick}
            >
              WHY US
            </NavLink>
          </div>
          <div className="linkzatopbar">
            <NavLink
              exact
              to="/contactus"
              activeClassName="active"
              className="nav-links"
              onClick={handleClick}
            >
              CONTACT US
            </NavLink>
          </div>
          <div className="linkzatopbar">
            <NavLink
              exact
              to="/aboutus"
              activeClassName="active"
              className="nav-links"
              onClick={handleClick}
            >
              ABOUT US
            </NavLink>
          </div>
        </div>
      </div>
      <div className="lowerup" />
    </>
  );
}
